<div class="btn {{btnClass}}" (click)="ShowPopup()"><i class="{{icon}}"></i>{{text}}</div> 
